import { ICauHoiProgressRequest } from "../../model/request/cau-hoi/ICauHoiProgressRequest";
import { ICauHoiSelectRequest } from "../../model/request/cau-hoi/ICauHoiSelectRequest";
import { ITongHopCauHoiRequest } from "../../model/request/cau-hoi/ITongHopCauHoiRequest";
import { ITongHopDeThiTracNghiemRequest } from "../../model/request/cau-hoi/ITongHopDeThiTracNghiemRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { apiClient } from "../apiClient";
export const CAU_HOI_ENDPOINT = "cau-hoi";
export const cauHoiApi = {
  SelectAll: () => apiClient.get(`${CAU_HOI_ENDPOINT}`),
  SelectById: (id: number) => apiClient.get(`${CAU_HOI_ENDPOINT}/${id}`),
  SelectPaging: (payload: ICauHoiSelectRequest) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/select-paging`, payload),
  Insert: (payload: any) => apiClient.post(`${CAU_HOI_ENDPOINT}`, payload),
  Update: (payload: any) => apiClient.put(`${CAU_HOI_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CAU_HOI_ENDPOINT}/${id}`),
  Deletes: (ids: number[]) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/deletes`, ids),
  ImportWord: (data: IProcessRequest<FormData>) =>
    apiClient.upload(
      `${CAU_HOI_ENDPOINT}/import-word/${data.process_id}`,
      data.payload,
    ),
  ExportWord: (payload: any) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/export-word`, payload),
  ExportExcel: (payload: any) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/export-excel`, payload),
  CheckDuplicate: (payload: ICauHoiSelectRequest) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/check-duplicate`, payload),
  TongHop: (payload: ITongHopCauHoiRequest) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/tong-hop`, payload),
  TongHopDeThiTracNghiem: (payload: ITongHopDeThiTracNghiemRequest) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/tong-hop-de-thi-tn`, payload),
  Progress: (payload: ICauHoiProgressRequest) =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/progress`, payload),
  SyncVNPT: () => apiClient.post(`${CAU_HOI_ENDPOINT}/sync-vnpt`),
  SyncKhongSuDungVNPT: () =>
    apiClient.post(`${CAU_HOI_ENDPOINT}/sync-khong-su-dung-vnpt`),
  ChangeUse: (id: number) =>
    apiClient.get(`${CAU_HOI_ENDPOINT}/change-use/${id}`),
};
